<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  props: {
    fundSource: {},
    busy: null,
  },
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {};
  },
  methods: {
    formatCurrency(data) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "PHP",
      }).format(data);
    },
    formatDate(data) {
      return new Date(data).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    },
    checkExpiry(data) {
      // return new Date() < new Date(data) ? true : false;
      return data.hasExpiry ? (new Date() < new Date(data.expiry) ? true : false) : true;
    },
    viewTransactions(data) {
      this.$emit("view-transactions", data);
    },
    processActualCash(data) {
      this.$emit("process-actual-cash", data);
    },
    updateItem(data) {
      this.$emit("update-item", data);
    },
    deleteItem(data) {
      this.$emit("delete-item", data);
    },
    viewOE(id) {
      this.$emit("view-oe", id);
    },
    viewSchedule(data) {
      this.$emit("view-schedule", { id: data.id, sourceName: data.sourceName });
    },
    printAllotment(id) {
      this.$emit("printAllotment", id);
    },
    printUtilization(id) {
      this.$emit("printUtilization", id);
    },
    printObligations(id) {
      this.$emit("printObligations", id);
    },
    printDisbursement(id) {
      this.$emit("printDisbursement", id);
    },
    printAllocation(id) {
      this.$emit("printAllocation", id);
    },
    showObligationModal(row) {
      this.$emit("view-obligations", row);
    },
    showDisbursementModal(row) {
      this.$emit("view-disbursements", row);
    },
    removeFavorites(data) {
      this.$swal({
        title: "Are you sure?",
        text: "You are removing this Fund Source from your favorites.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, remove it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit("remove-favorites", data);
        }
      });
    },
  },
  mounted: function () {
    // var menuRef = new MetisMenu("#side-menu");
  },
};
</script>

<template>
  <div>
    <carousel :autoplayHoverPause="true"
              :navigationEnabled="true"
              :paginationEnabled="false"
              :scrollPerPage="true"
              :perPage="3"
              :speed="1000"
              :autoplayTimeout="10000">
      <slide v-for="source in fundSource"
             :key="source.id">
        <div>
          <div class="card">
            <div class="card-body">
              <div class="float-end">
                <b-button variant="link"
                          size="sm"
                          :id="`popover-target-favorites-${source.id}`">
                  <i class="fas fa-ellipsis-h"></i>
                </b-button>
                <b-popover :target="`popover-target-favorites-${source.id}`"
                           triggers="click blur"
                           placement="leftbottom"
                           variant="secondary"
                           custom-class="p-0 p-custom-class">
                  <div class="accordion w-100"
                       role="tablist">
                    <b-card no-body
                            class="mb-0">
                      <b-card-header header-tag="header"
                                     class="p-0">
                        <b-list-group-item button
                                           action
                                           tabindex="0"
                                           v-b-toggle.accordion-1
                                           class="list-group-item list-group-item-action text-dark text-left">
                          <i class="far fa-list-alt font-size-15 align-middle me-2"></i>
                          Transactions
                        </b-list-group-item>
                      </b-card-header>
                      <b-collapse id="accordion-1"
                                  accordion="my-accordion"
                                  role="tabpanel">
                        <b-card-text>
                          <b-list-group class="w-100">
                            <b-list-group-item button
                                               action
                                               @click="viewTransactions(source)"><i
                                 class="mdi mdi-bank-transfer font-size-18 align-middle me-2"></i>View Transactions
                            </b-list-group-item>

                            <b-list-group-item button
                                               action
                                               @click="showObligationModal(source)">
                              <i class="mdi mdi-newspaper-variant-outline font-size-18 align-middle me-2"></i>View
                              Obligations
                            </b-list-group-item>

                            <b-list-group-item button
                                               action
                                               @click="showDisbursementModal(source)">
                              <i class="mdi mdi-newspaper-variant-outline font-size-18 align-middle me-2"></i>View
                              Disbursements
                            </b-list-group-item>
                          </b-list-group>
                        </b-card-text>
                      </b-collapse>
                    </b-card>
                    <b-card no-body
                            class="mb-0">
                      <b-card-header header-tag="header"
                                   class="p-0"
                                   role="tab">
                        <b-list-group-item button
                                           action
                                           tabindex="0"
                                           v-b-toggle.accordion-2
                                           class="list-group-item list-group-item-action text-dark text-left"><i
                             class="fas fa-tools font-size-15 align-middle me-2"></i>
                          Options</b-list-group-item>
                      </b-card-header>
                      <b-collapse id="accordion-2"
                                  accordion="my-accordion"
                                  role="tabpanel">
                        <b-card-text>
                          <b-list-group class="w-100">
                            <b-list-group-item action
                                               @click="viewOE(source.id)">
                              <i class="mdi mdi-view-list font-size-18 align-middle me-2"></i>View Accounts
                            </b-list-group-item>
                            <b-list-group-item action
                                               @click="viewSchedule(source)"><i
                                 class="bx bx-calendar font-size-18 align-middle me-2"></i>Utilization Schedule
                            </b-list-group-item>
                            <b-list-group-item action
                                               @click="updateItem(source)"><i
                                 class="bx bx-edit font-size-18 align-middle me-2"></i>Edit
                            </b-list-group-item>
                            <b-list-group-item action
                                               @click="deleteItem(source)"><i
                                 class="mdi mdi-trash-can font-size-18 align-middle me-2"></i>Delete</b-list-group-item>
                          </b-list-group>
                        </b-card-text>
                      </b-collapse>
                    </b-card>
                    <b-card no-body
                            class="mb-0">
                      <b-card-header header-tag="header"
                                     class="p-0"
                                     role="tab">
                        <b-list-group-item button
                                           action
                                           tabindex="0"
                                           v-b-toggle.accordion-3
                                           class="list-group-item list-group-item-action text-dark text-left"><i
                             class="far fa-file-alt font-size-15 align-middle me-2"></i>
                          Reports</b-list-group-item>
                      </b-card-header>
                      <b-collapse id="accordion-3"
                                  accordion="my-accordion"
                                  role="tabpanel">
                        <b-card-text>
                          <b-list-group class="w-100">
                            <b-list-group-item action
                                               @click="printAllotment(source.id)">
                              <i class="bx bx-receipt font-size-18 align-middle me-2"></i>Expenditure Allotment
                            </b-list-group-item>
                            <b-list-group-item action
                                               @click="printUtilization(source.id)"><i
                                 class="bx bx-money font-size-18 align-middle me-2"></i>Utilization Report
                            </b-list-group-item>
                            <b-list-group-item action
                                               @click="printObligations(source.id)"><i
                                 class="bx bx-poll font-size-18 align-middle me-2"></i>Obligation Report
                            </b-list-group-item>
                            <b-list-group-item action
                                               @click="printDisbursement(source.id)"><i
                                 class="mdi mdi-book-arrow-right-outline font-size-18 align-middle me-2"></i>Disbursement
                              Report
                            </b-list-group-item>
                            <b-list-group-item action
                                               @click="printAllocation(source.id)"><i
                                 class="mdi mdi-file-chart-outline font-size-18 align-middle me-2"></i>Allocation Report
                            </b-list-group-item>
                          </b-list-group>
                        </b-card-text>
                      </b-collapse>
                    </b-card>
                  </div>
                </b-popover>
              </div>
              <div class="d-flex flex-wrap justify-content-between mb-0">
                <div>
                  <h5 class="fs-17 mb-0 mt-0"
                      :title="`Description: ${source.description}`">
                    {{ source.sourceName }}
                    <b-button variant="link"
                              class="ms-1 p-0"
                              @click="removeFavorites(source)">
                      <i class="mdi mdi-trash-can-outline text-danger font-size-15"></i>
                    </b-button>
                  </h5>
                  <!-- <p class="mb-0 text-muted" title="Fund Source Description">
                      <small class="text-dark">{{  }}</small>
                    </p> -->
                  <span class="badge rounded-pill mb-1"
                        :class="{
                          'badge-soft-success': checkExpiry(source),
                          'badge-soft-danger': !checkExpiry(source),
                        }">
                    <span v-if="checkExpiry(source)">Active</span>
                    <span v-if="!checkExpiry(source)">Expired</span>
                  </span>
                  <small v-if="source.hasExpiry"
                         class="ms-1"><span v-if="checkExpiry(source)">until</span><span
                          v-if="!checkExpiry(source)">on</span>
                    {{ formatDate(source.expiry) }}
                  </small>
                </div>
                <div class="mb-0 mt-0 me-5">
                  <small class="mb-0 d-block">
                    <span>Bank: </span><strong class="text-info">{{ source.bankName }}</strong>
                  </small>
                  <small class="mb-0 d-block">
                    <span>Account No: </span><strong class="text-info">{{ source.accountNumber }}</strong>
                  </small>
                </div>
              </div>

              <ul class="list-inline mb-0 mt-3">
                <li class="list-inline-item">
                  <span class="badge rounded-1 badge-soft-success"
                        title="Allocated">{{
                          formatCurrency(source.allocated)
                        }}</span>
                </li>
                <li class="list-inline-item">
                  <span class="badge rounded-1 badge-soft-warning"
                        title="Total Available">{{ formatCurrency(source.balance) }}</span>
                </li>
                <li class="list-inline-item">
                  <span class="badge rounded-1 badge-soft-info"
                        title="Total Obligations">{{ formatCurrency(source.totalObligations) }}</span>
                </li>
                <li class="list-inline-item">
                  <span class="badge rounded-1 badge-soft-secondary"
                        title="Total Disbursement">{{ formatCurrency(source.totalDisbursement) }}</span>
                </li>
                <li class="list-inline-item">
                  <span class="badge rounded-1 badge-soft-danger"
                        title="Actual Cash Balance">{{ formatCurrency(source.actualCashBalance) }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<style lang="scss">
.p-custom-class .popover-body {
  padding: 0 !important;
  border: 0 !important;
}

.p-custom-class .list-group-item {
  border: 0 !important;
}
</style>
